import Vue from 'vue'
import axios from 'axios'
import util from './util'
import basedata from './basedata'

let vm = new Vue()

function post(url, data = {}, that) {
	let Addurl = basedata.postUrl + url
	
	if (!!util.getStoObj('allinfo')) {
		// data.PlatformType = util.getStoObj('allinfo').PlatformType;
		// data.ADS_UserId = util.getStoObj('allinfo').ADS_UserId;
		// data.UserId = util.getStoObj('allinfo').ADS_UserId;
		// data.IsLogin = !!util.getStoObj('allinfo').Eshop_Mobile ? '1' : '0';
		// data.OrdHelperMemId = util.getStoObj('allinfo').OrdHelperMemId;
		// data.OrdHelperToken = util.getStoObj('allinfo').OrdHelperToken;
		// data.QRcode_Type = 3;
		// data.ShareActivityId = 0;
		// data.ShareUserId = 0;
		if(url == 'Ca_AcProducts/GetAcProductListBySearch'){
			data.ShopCode=util.getStoObj('allinfo').ShopCode;
			data.Mobile=util.getStoObj('allinfo').Eshop_Mobile;
		}
	}

	return new Promise((resolve, reject) => {
		// if(url != 'Ca_AcProducts/AddOrder'){
		axios.post(Addurl, data, that).then(response => {
			if (response.data.ResultType === 1) {
				resolve(response.data);
				that.$parent.Loading(false)
				if (!!response.data.Data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.Data.OrdHelperToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.OrdHelperToken;
					}
					util.setStoObj('allinfo', allinfo)
				}
			} else {
				util.toast(response.data.Message)
				that.$parent.Loading(false)
			}
		}).catch(err => {
			reject(err);
			if(that) {
				that.$parent.Loading(false)
			}
			// util.toast('网络异常')
		})
		// }
	})
}

function post2(url, data = {}, that) {
	let Addurl = url
	// if (!!util.getStoObj('allinfo')) {
	// 	data.PlatformType = util.getStoObj('allinfo').PlatformType;
	// 	data.ADS_UserId = util.getStoObj('allinfo').ADS_UserId;
	// 	data.UserId = util.getStoObj('allinfo').ADS_UserId;
	// 	data.IsLogin = !!util.getStoObj('allinfo').Eshop_Mobile ? '1' : '0';
	// 	data.OrdHelperMemId = util.getStoObj('allinfo').OrdHelperMemId;
	// 	data.OrdHelperToken = util.getStoObj('allinfo').OrdHelperToken;
	// 	data.QRcode_Type = 3;
	// 	data.ShareActivityId = 0;
	// 	data.ShareUserId = 0;
	// }
	
	return new Promise((resolve, reject) => {
		// if(url != 'Ca_AcProducts/AddOrder'){
		axios.post(Addurl, data,{headers: {'Token':sessionStorage.getItem('QPT_UserToken')}}, that).then(response => {
			if (response.data.ResultType === 1) {
				resolve(response.data);
				that.$parent.Loading(false)
				if (!!response.data.Data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.Data.OrdHelperToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.OrdHelperToken;
					}
					util.setStoObj('allinfo', allinfo)
				}
			} else {
				util.toast(response.data.Message)
				that.$parent.Loading(false)
			}
		}).catch(err => {
			reject(err);
			that.$parent.Loading(false)
			// util.toast('系统繁忙，请稍后重试！！')
		})
		// }
	})
}

function postNoLoading(url, data = {}) {
	let Addurl = basedata.postUrl + url
	if (!!util.getStoObj('allinfo')) {
	
		if(url == 'Ca_AcProducts/GetAcProductListBySearch'){
			data.ShopCode=util.getStoObj('allinfo').ShopCode;
			data.Mobile=util.getStoObj('allinfo').Eshop_Mobile;
		}
	}
	return new Promise((resolve, reject) => {
		axios.post(Addurl, data).then(response => {
			if (response.data.ResultType === 1) {
				resolve(response.data);
				if (!!response.data.Data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.NewToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.NewToken;
					}
					util.setStoObj('allinfo', allinfo)
				} else if (!!response.data.Data.OrdHelperToken) {
					var allinfo = util.getStoObj("allinfo");
					if(allinfo){
						allinfo.OrdHelperToken = response.data.Data.OrdHelperToken;
					}
					util.setStoObj('allinfo', allinfo)
				}
			} else {
				util.toast(response.data.Message)
				// that.$parent.Loading(false)
			}
		}).catch(err => {
			reject(err);
			// that.$parent.Loading(false)
			// util.toast('网络异常')
		})
	})
}


let getListByPage = function(that, isFirst, callback) {
	that.pageData.params.CurrentPage = that.pageData.params.CurrentPage || 1;
	that.pageData.params.PageSize = 20;
	if (isFirst) {
		that.pageData.infoList = [];
		that.pageData.params.CurrentPage = 1;
	}
	if (that.pageData.params.CurrentPage > that.pageData.TotalPage || that.pageData.isLoading) {
		that.$parent.Loading(false)
		return
	} else {
		that.$parent.Loading(true)
		that.pageData.isLoading = true;
		postNoLoading(that.pageData.postUrl, that.pageData.params).then(res => {
			that.pageData.isLoading = false;
			that.$parent.Loading(false)
			let listArr = [];
			if (that.pageData.postUrl == 'Ca_AcProducts/ShoppingCartProductList') {
				// 购物车列表
				listArr = res.Data.CartProductList;
			} else if (that.pageData.postUrl == 'Ca_AcProducts/GetAcProductListBySearch') {
				// 产品搜索
				listArr = res.Data.ProductInfo_Comm_List;
			} else {
				listArr = res.Data.infoList;
			}
			// if (!!res.Data.ShenHeStatus) {
			that.ShenHeStatus = res.Data.ShenHeStatus;
			// }
			// if (!!res.Data.IsADS) {
			that.IsADS = res.Data.IsADS;
			// }
			if (isFirst) {
				that.pageData.infoList = listArr;
			} else {
				that.pageData.infoList = that.pageData.infoList.concat(listArr);
			}
			that.pageData.TotalPage = res.Data.TotalPage == 0 ? 1 : res.Data.TotalPage;
			that.pageData.totalNum = res.Data.length * res.Data.TotalPage;

			if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
				that.pageData.params.CurrentPage++;
			}

			for (let i in res.Data) {
				if (i == 'infoList' || i == 'CurrentPage' || i == 'TotalPage') {} else {
					that.pageData[i] = res.Data[i];
				}
			}

			if (callback) {
				callback();
			}
		})
	}
}

let getListByPage0 = function(that, isFirst, callback) {
	that.pageData.params.CurrentPage = that.pageData.params.CurrentPage || 0;
	that.pageData.params.PageSize = 20;
	if (isFirst) {
		that.pageData.infoList = [];
		that.pageData.params.CurrentPage = 0;
	}
	that.$parent.Loading(false);
	if (that.pageData.params.CurrentPage > that.pageData.TotalPage || that.pageData.isLoading) {
		return
	} else {
		that.pageData.isLoading = true;
		postNoLoading(that.pageData.postUrl, that.pageData.params).then(res => {
			that.pageData.isLoading = false;
			let listArr = [];
			if (that.pageData.postUrl == 'Ca_AcProducts/ShoppingCartProductList') {
				// 购物车列表
				listArr = res.Data.CartProductList;
			} else if (that.pageData.postUrl == 'Ca_AcProducts/GetAcProductListBySearch') {
				// 产品搜索
				for (var i = 0; i < res.Data.ProductInfo_Comm_List.length; i++) {
					if (res.Data.ProductInfo_Comm_List[i].ImgUrl != null) {
						res.Data.ProductInfo_Comm_List[i].ImgUrl = res.Data.ProductInfo_Comm_List[i].ImgUrl.split(',')[0];
					}
				}
				listArr = res.Data.ProductInfo_Comm_List;
			} else {
				listArr = res.Data.infoList;
			}
			// if (!!res.Data.ShenHeStatus) {
			that.ShenHeStatus = res.Data.ShenHeStatus;
			// }
			// if (!!res.Data.IsADS) {
			that.IsADS = res.Data.IsADS;
			// }
			if (isFirst) {
				that.pageData.infoList = listArr;
				that.$parent.Loading(false);
			} else {
				that.$parent.Loading(false);
				that.pageData.infoList = that.pageData.infoList.concat(listArr);
				that.$parent.Loading(false);
			}
			that.pageData.TotalPage = res.Data.TotalPage == 0 ? 1 : res.Data.TotalPage;
			that.pageData.totalNum = res.Data.length * res.Data.TotalPage;

			if (that.pageData.params.CurrentPage <= that.pageData.TotalPage) {
				that.pageData.params.CurrentPage++;
			}

			for (let i in res.Data) {
				if (i == 'infoList' || i == 'CurrentPage' || i == 'TotalPage') {} else {
					that.pageData[i] = res.Data[i];
				}
			}

			if (callback) {
				callback();
			}
		})
	}
}
export default {
	post,
	post2,
	postNoLoading,
	getListByPage,
	getListByPage0,
}
